import { buildStateEvent, GenericStateEvent } from '../../common-redux'
import { Worklog } from './model'

export interface WorklogStateEvent<T> extends GenericStateEvent<T> {}

export const GetAllWorklogByIncidentIdSuccessEvent = {
    type: 'GetAllWorklogByIncidentIdSuccessEvent',
    build: (payload: Worklog[]) => buildStateEvent(GetAllWorklogByIncidentIdSuccessEvent.type, payload)
}
